// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:02:27

export default {
  "id": "9-blocks",
  "slug": "9-blocks",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e0457af437a64114923c9304f55d6ecb-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e0457af437a64114923c9304f55d6ecb/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "9 Blocks",
      "description": "Logical puzzle game with original gameplay. The goal is to fill all empty places in a chip merging with chips next to this one.",
      "instructions": "Rotate and drag chips to each other to combine their contained squares to make a full-filled chip.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "2d",
        "logic",
        "logical",
        "tetris"
      ]
    },
    "zh-CN": {
      "title": "九方块",
      "description": "逻辑益智游戏，具有原创的游戏玩法。目标是填充所有空白位置，通过将芯片与相邻的芯片合并来实现。",
      "instructions": "旋转并拖动筹码，将它们相邻组合，以拼成满格筹码。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "2D",
        "逻辑",
        "逻辑的",
        "俄罗斯方块"
      ]
    },
    "zh-TW": {
      "title": "九塊",
      "description": "邏輯謎題遊戲，具有獨特遊戲玩法。目標是填滿所有空位，通過與旁邊的晶片合併。",
      "instructions": "旋轉並拖動磁片相互靠近，以合併其內含的方格，製成滿滿的磁片。",
      "genres": [
        "休闲",
        "拼圖"
      ],
      "tags": [
        "1玩家",
        "2D",
        "運理,邏輯",
        "俄羅斯方塊"
      ]
    },
    "zh-HK": {
      "title": "九塊",
      "description": "邏輯謎題遊戲，具獨特遊戲玩法。目標是填滿所有空白位置，透過與旁邊的芯片合併來完成。",
      "instructions": "旋轉並拖移骰子，將其中包含的方格合併，製成一個滿載的骰子。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "2D",
        "邏輯",
        "邏輯性",
        "俄罗斯方塊"
      ]
    },
    "ja": {
      "title": "9ブロック",
      "description": "オリジナルのゲームプレイを持つ論理パズルゲームです。目標は、チップを隣接するチップと合体させてすべての空き場所を埋めることです。",
      "instructions": "チップを回転させ、ドラッグして他のチップと組み合わせ、内蔵する四角形を全て満たしたチップにします。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "ロジック",
        "論理的",
        "テトリス"
      ]
    },
    "ko": {
      "title": "9 블록",
      "description": "논리적 퍼즐 게임으로 독특한 게임 플레이를 제공합니다. 목표는 모든 공간을 칩을 이어 붙이며 다음 칩과 합쳐 모두 메우는 것입니다.",
      "instructions": "칩을 돌려서 서로 끌어당겨 내에 있는 사각형을 결합하여 가득 찬 칩을 만들어주세요.",
      "genres": [
        "캐주얼",
        "پازل"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "로직",
        "논리적",
        "테트리스"
      ]
    },
    "fr": {
      "title": "9 Blocs",
      "description": "Jeu de puzzle logique avec un gameplay original. Le but est de remplir tous les espaces vides sur une puce en la fusionnant avec les puces adjacentes.",
      "instructions": "Tournez et glissez les jetons les uns vers les autres pour combiner les carrés qu'ils contiennent et former un jeton complet.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "logique",
        "logique",
        "Tetris"
      ]
    }
  }
};
